export enum BasesStorageKey {
  LIST_BASES = 'listBases',
  ADD_BASE_FORM = 'addBaseForm',
}
